import { InputBase, InputLabel, IconButton } from '@mui/material'
import { Box } from '@mui/system'
import classNames from 'classnames'
import { useField, useFormikContext } from 'formik'
import { CloseIcon } from 'src/components/shared/ui/Icons'
import { fieldsStyles as styles } from 'src/components/shared/ui/form/fields/fieldsStyles'
import { EscritosFormValues } from 'src/components/views/EscritosLexnet/components/shared/types/escritosFormTypes'

type Props = {
  id: string
  label: string
  maxLength?: number
  readOnly?: boolean
  required?: boolean
  disabled?: boolean
}

function TextareaField({
  id,
  label,
  maxLength,
  readOnly = false,
  required = false,
  disabled = false
}: Props): JSX.Element {
  const { setFieldValue, setFieldTouched } = useFormikContext<EscritosFormValues>()
  const [fieldInfo, meta] = useField(id)

  const inputClassNames = classNames({
    disabled,
    required,
    error: meta.touched && meta.error
  })

  return (
    <div>
      <InputLabel id={`${id}-label`} className={inputClassNames}>
        {label}
      </InputLabel>
      <InputBase
        id={id}
        readOnly={readOnly}
        sx={styles.input}
        className={inputClassNames}
        multiline
        rows={5}
        inputProps={{ maxLength }}
        onChange={e => {
          const { value } = e.target
          setFieldValue(id, value, true)
          if (!value) {
            setFieldTouched(id, true, false)
          }
        }}
        onBlur={fieldInfo.onBlur}
        value={fieldInfo.value}
        disabled={disabled}
        endAdornment={
          fieldInfo.value && (
            <IconButton
              aria-label="close"
              onClick={() => {
                setFieldValue(id, '', true)
                setFieldTouched(id, true, false)
              }}
              sx={styles.closeButton}
            >
              <CloseIcon />
            </IconButton>
          )
        }
      />
      <Box sx={styles.helpTextContainer}>
        <Box component="span" sx={styles.helpErrorText}>
          {meta.touched ? meta.error : null}
        </Box>
        <Box component="span">
          {maxLength && fieldInfo.value && `${fieldInfo.value.length} / ${maxLength}`}{' '}
        </Box>
      </Box>
    </div>
  )
}

export default TextareaField
